import { render } from "./PolicyRulePort.vue?vue&type=template&id=3e96d0a0"
import script from "./PolicyRulePort.vue?vue&type=script&lang=js"
export * from "./PolicyRulePort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__